import { render, staticRenderFns } from "./ClientProjects.vue?vue&type=template&id=700e2be6&scoped=true&"
import script from "./ClientProjects.vue?vue&type=script&lang=js&"
export * from "./ClientProjects.vue?vue&type=script&lang=js&"
import style0 from "./ClientProjects.vue?vue&type=style&index=0&id=700e2be6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700e2be6",
  null
  
)

export default component.exports